import { useFormConfigStore } from "../../state/store";
import { DropdownOptionsSection } from "./DropdownOptionsSection";
import { LookupConfigSection } from "./LookupConfigSection";

/**
 * Type-specific section dispatcher — renders ONE additional section
 * below the always-present Identity / Display / Behavior / OCR /
 * Conditional Visibility stack, based on the selected field's
 * `dataType`:
 *
 *   - `dropdown` → DropdownOptionsSection (inline value/label list)
 *   - `lookup`   → LookupConfigSection    (table + display/return columns)
 *   - any other  → renders nothing (no extra config required)
 *
 * Subscribes to the store directly (zero props) — same pattern as the
 * other drawer sections so dataType changes from IdentitySection
 * automatically swap the content here.
 */
export function TypeSpecificSection() {
  const content = useFormConfigStore((s) => s.content);
  const selectedFieldName = useFormConfigStore((s) => s.selectedFieldName);

  const field = content?.fields.find((f) => f.name === selectedFieldName) ?? null;
  if (!field) return null;

  switch (field.dataType) {
    case "dropdown":
      return <DropdownOptionsSection />;
    case "lookup":
      return <LookupConfigSection />;
    default:
      return null;
  }
}
